import axios from "axios";
import { baseURL } from "../data/configs";

// eslint-disable-next-line import/no-anonymous-default-export
export default function (apiKey) {
  return axios.create({
    baseURL,
    headers: {'X-API-KEY': apiKey }
  });
}